<div class="auth-container">
  <div class="content">
    <div class="form-container">
      <div class="form-header">
        <img src="/assets/images/logo.png" class="form-logo" alt="logo" />
        <div class="title-wrapper">
          <h1 class="form-title reset-title">Reset Password</h1>
          <div *ngIf="errorMessage" class="invalid">
            <p class="text">{{ errorMessage }}</p>
          </div>
        </div>
      </div>
      <form
        *ngIf="isTokenValid"
        nz-form
        class="form"
        nzLayout="vertical"
        [formGroup]="resetPasswordForm"
        (ngSubmit)="onSubmit()">
        <nz-form-item>
          <nz-form-label nzFor="password" nzRequired>Password</nz-form-label>
          <nz-form-control [nzErrorTip]="passwordErrorTpl">
            <nz-input-group [nzSuffix]="suffixTemplate">
              <input
                id="password"
                [type]="passwordVisible ? 'text' : 'password'"
                formControlName="newPassword"
                nz-input
                placeholder="New Password" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <span
                nz-icon
                [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"
                (keydown.enter)="passwordVisible = !passwordVisible"
                (keydown.space)="passwordVisible = !passwordVisible"
                role="button"
                tabindex="0"
                aria-label="Toggle password visibility"
                style="cursor: pointer"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="confirmpassword" nzRequired
            >Confirm Password</nz-form-label
          >
          <nz-form-control [nzErrorTip]="confirmPasswordErrorTpl">
            <nz-input-group [nzSuffix]="suffixConfirmTemplate">
              <input
                id="confirmpassword"
                [type]="passwordConfirmVisible ? 'text' : 'password'"
                formControlName="confirmPassword"
                nz-input
                placeholder="Confirm Password" />
            </nz-input-group>
            <ng-template #suffixConfirmTemplate>
              <span
                nz-icon
                [nzType]="passwordConfirmVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordConfirmVisible = !passwordConfirmVisible"
                (keydown.enter)="
                  passwordConfirmVisible = !passwordConfirmVisible
                "
                (keydown.space)="
                  passwordConfirmVisible = !passwordConfirmVisible
                "
                role="button"
                tabindex="0"
                aria-label="Toggle password visibility"
                style="cursor: pointer"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <button
          nz-button
          type="submit"
          [disabled]="!resetPasswordForm.valid || isLoading"
          [nzLoading]="isLoading"
          [nzBlock]="true"
          class="form-button"
          [nzType]="'primary'">
          Reset Password
        </button>
      </form>
    </div>
  </div>
</div>

<ng-template #passwordErrorTpl>
  <ng-container *ngIf="resetPasswordForm.get('newPassword')?.errors as errors">
    <span *ngIf="errors['required']"> Password is required </span>
    <span *ngIf="!errors['required'] && errors['minlength']">
      Password must be at least 8 characters long
    </span>
    <span
      *ngIf="
        !errors['required'] &&
        !errors['minlength'] &&
        errors['passwordStrength']
      ">
      Password must include uppercase, lowercase, number and special character
    </span>
  </ng-container>
</ng-template>

<ng-template #confirmPasswordErrorTpl>
  <div
    *ngIf="
      resetPasswordForm.get('confirmPassword')?.touched ||
      resetPasswordForm.get('confirmPassword')?.dirty
    ">
    <ng-container *ngIf="resetPasswordForm.hasError('passwordsMismatch')">
      <span>Passwords do not match</span>
    </ng-container>
    <ng-container
      *ngIf="resetPasswordForm.get('confirmPassword')?.errors as errors">
      <span *ngIf="errors['required']">Confirmation Password is required</span>
    </ng-container>
  </div>
</ng-template>
